import { type FC } from 'react';
import classnames from 'classnames';
import { FormattedMessage } from 'dibs-react-intl';
import dibsCss from 'dibs-css';

import loadingShimmer from '../../styles/hpLoadingShimmer.scss';

type HpSharedFeaturedItemsTitleProps = {
    isMobile: boolean;
    isLoading?: boolean;
};

export const HpSharedFeaturedItemsTitle: FC<HpSharedFeaturedItemsTitleProps> = ({
    isMobile,
    isLoading,
}) => {
    return (
        <div
            className={classnames(
                isMobile
                    ? [dibsCss.sassyFontHeaderLarge, dibsCss.mtMedium, dibsCss.mbSmall]
                    : [
                          dibsCss.sassyFontHeaderXLarge,
                          dibsCss.mtLarger,
                          dibsCss.mbMedium,
                          dibsCss.textCenter,
                      ]
            )}
        >
            <span className={classnames(isLoading && loadingShimmer.shimmer)}>
                <span className={classnames(isLoading && dibsCss.invisible)}>
                    <FormattedMessage
                        id="HpSharedFeaturedItemsCarousel.title"
                        defaultMessage="Featured Items <italic>For You</italic>"
                        values={{
                            italic: chunks => <em>{chunks}</em>,
                        }}
                    />
                </span>
            </span>
        </div>
    );
};
